export const SET_ACCOUNTS = "SET_ACCOUNTS";
export const SET_POSTS = "SET_POSTS";
export const SET_LEADS = "SET_LEADS";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_FETCHED_ACCOUNT = "SET_FETCHED_ACCOUNT";
export const SET_FETCHED_POSTS = "SET_FETCHED_POSTS";
export const SET_FETCHED_LEADS = "SET_FETCHED_LEADS";
export const SET_FETCHED_MESSAGES = "SET_FETCHED_MESSAGES";
